<template>
  <transition name="el-zoom-in-center">
    <div class="bg-contain common-blue-contain ">
      <div class="breadcrumb-tilte">{{ $t('mediaData') }}</div>
      <DataType @handleItem="handleItem" ref="dataType" :dataUserId="dataUserId"></DataType>
      <div class="common-main">
        <!-- 查询 -->
        <div class="search search-container">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item v-if="searchType === 'type'" :label="$t('mechanism')">
              <el-select
                ref="paramOuSelect"
                v-model="ouName"
                style="width:auto"
                :placeholder="$t('peaseSelect')"
                :popper-append-to-body="false"
                @clear="clearParamOuTree"
                clearable
                @visible-change="visibleChange"
              >
                <el-option :value="ouName" style="height:auto;padding:0px;line-height: 1;">
                  <el-tree
                    ref="paramOuTree"
                    node-key="id"
                    default-expand-all
                    highlight-current
                    :expand-on-click-node="false"
                    :data="ouList"
                    :props="defaultProps"
                    @node-click="selectParamOu"
                  >
                  </el-tree>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="searchType === 'user'" :label="$t('category')">
              <el-select
                ref="paramOuSelect"
                v-model="ouName"
                style="width:auto"
                :placeholder="$t('peaseSelect')"
                :popper-append-to-body="false"
                @clear="clearParamOuTree"
                clearable
              >
                <el-option :value="ouName" style="height:auto;padding:0px">
                  <el-tree
                    ref="paramOuTree"
                    node-key="id"
                    default-expand-all
                    highlight-current
                    :expand-on-click-node="false"
                    :data="userList"
                    :props="defaultProps"
                    @node-click="selectParamOu"
                  >
                  </el-tree>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('userNameH')">
              <el-input
                v-model="formInline.userName"
                clearable
                :placeholder="$t('userNameH')"
                @input="handleClear"
                @clear="handleClear"
              ></el-input>
            </el-form-item>

            <el-form-item :label="$t('Recordtime')" class="datetime">
              <el-date-picker
                v-model="formInline.logTimestampBegin"
                :placeholder="$t('startDate')"
                type="date"
                value-format="yyyy-MM-dd"
                popper-class="date-picker-blue-hw"
                :clearable="true"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('TO')">
              <el-date-picker
                v-model="formInline.logTimestampEnd"
                :placeholder="$t('endDate')"
                type="date"
                value-format="yyyy-MM-dd"
                popper-class="date-picker-blue-hw"
                :clearable="true"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('fileType')">
              <el-select
                v-model="formInline.mediaType"
                clearable
                :placeholder="$t('fileType')"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item of positionTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getList" class="serachBtn">{{ $t('query') }}</el-button>
              <el-button type="primary" @click="handleDownload" class="serachBtn" :loading="downloadLoading">{{ $t('download') }}</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="cate-content">
          <div class="content">
            <div style="height: 40px;" class="content-select">
              <el-checkbox
                class="select-all"
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="allSelect"
                v-if="showType"
              >
                {{ $t('selectAll') }}
              </el-checkbox>
              <el-button type="primary" @click="classify" class="serachBtn select-all" size="small" v-if="!showType">{{
                $t('classificatManag')
              }}</el-button>
              <div class="sieve-series">
                <el-radio-group v-model="sortRadio" size="small">
                  <el-radio-button
                    v-for="(item, index) in radioData"
                    :key="index"
                    :label="item.label"
                    @click.native="handlecoll($event, item.label)"
                    >{{ item.name }}
                    <i
                      v-if="sortRadio === item.label"
                      class="icon-right"
                      :class="formInline.sort === 'asc' ? 'icon-downLight' : 'icon-uploadLight'"
                    ></i>
                    <i v-else class="icon-right" :class="'icon-download'"></i>
                  </el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <div class="medias">
              <el-checkbox-group v-model="checkboxGroup1" class="groups">
                <div
                  v-for="(item, index) of mediaList"
                  :key="index"
                  class="media-item"
                  :class="showType ? 'type-item' : ' '"
                >
                  <!-- 视频 -->
                  <div class="tags-list" v-if="item.mediaType === 1">
                    <div class="exVideo" v-if="videoShow && item.id === firstId">
                      <vue-draggable-resizable
                        :w="width"
                        :h="height"
                        :x="x"
                        :y="y"
                        :min-width="350"
                        :min-height="250"
                        :parent="false"
                        :grid="[10, 10]"
                        id="amplifyVideo"
                        class-name="dragging1"
                        @dragging="onDrag"
                        @resizing="onResize"
                        :draggable="allowDrag"
                      >
                        <div class="exVideoTitle">
                          <span>{{ $t('History') }}</span>
                          <i class="sys-close-btn" @click.stop="cancleVideoShow"></i>
                        </div>
                        <!-- 视频组播放器 -->
                        <HistoryVideo
                          v-if="item.group"
                          :videoSrcArr="playVideoData"
                          :index.sync="videoIndex"
                          :videoShow.sync="videoShow"
                          @searchList="searchList"
                          :showPrevNext="false"
                          :userData="historyData"
                          @getAllow="getAllow"
                          :width="780"
                          :height="560"
                        >
                        </HistoryVideo>
                        <!-- 单独视频播放 -->
                        <OneHistoryVideo
                          v-else
                          :videoSrcArr="playVideoData"
                          :index.sync="videoIndex"
                          :videoShow.sync="videoShow"
                          @searchList="searchList"
                          :showPrevNext="false"
                          :userData="historyData"
                          :allowDrag.sync="allowDrag"
                        ></OneHistoryVideo>
                      </vue-draggable-resizable>
                    </div>
                    <el-checkbox
                      :label="item"
                      class="check-item"
                      @click.stop.native="() => {}"
                    ></el-checkbox>
                    <div class="cate-type" v-if="item.fullTypeAttributeName">
                      <img src="@/icon/cate.png" class="cate" title="切换类别" />
                      <span v-if="item.mediaTypeName"> {{ item.mediaTypeName }}</span>
                    </div>
                    <div class="delete uper-delete" v-if="item.status === 1">
                      <img class="upper" src="@/icon/monitor/delete.png" />
                      <h5 class="upper-text">{{ $t('Deleted') }}</h5>
                    </div>
                    <!-- 未上传 -->
                    <div v-else-if="!item.uploadFlag" class="delete">
                      <img class="upper" src="@/icon/monitor/notUploaded.png" />
                      <h5 class="upper-text">{{ $t('NotUploaded') }}</h5>
                    </div>
                    <div v-else class="box" @click="playMedia(item)">
                      <img
                        v-if="item.preMediaUrl === null || item.preMediaUrl === ''"
                        :src="isDefaultTheme ? coverSrcDefault : coverSrc"
                        class="pic"
                        :lazy="true"
                        alt=""
                        style="width: 100%; height: 100%"
                      />
                      <img
                        v-else
                        :src="item.preMediaUrl"
                        class="pic"
                        :lazy="true"
                        alt=""
                        style="width: 100%; height: 100%"
                      />
                      <img src="@/icon/new-common/icon_play.png" class="play-icon" />
                    </div>

                    <h5 class="vedio-time">
                      <p class="local" :class="item.location ? '' : 'local-height'">
                        {{ item.userName }} | {{ item.startTimestamp ? item.startTimestamp : item.logTimestamp }}
                      </p>
                      <el-tooltip effect="dark" :content="item.location" placement="bottom">
                        <p class="local" v-if="item.location">{{ $t('positionB') }}: {{ item.location }}</p>
                      </el-tooltip>
                    </h5>
                  </div>
                  <!-- 图片 -->
                  <div class="tags-list" v-if="item.mediaType === 2">
                    <el-checkbox
                      :label="item"
                      class="check-item"
                      @click.stop.native="() => {}"
                    ></el-checkbox>
                    <div class="cate-type" v-if="item.fullTypeAttributeName">
                      <img src="@/icon/cate.png" class="cate" title="切换类别" />
                      <span v-if="item.mediaTypeName"> {{ item.mediaTypeName }}</span>
                    </div>
                    <el-image
                      :src="item.mediaUrl"
                      :title="item.location"
                      class="pic"
                      :preview-src-list="[item.mediaUrl]"
                    >
                    </el-image>
                    <h5 class="vedio-time">
                      <p class="local" :class="item.location ? '' : 'local-height'">
                        {{ item.userName }} | {{ item.logTimestamp }}
                      </p>
                      <el-tooltip effect="dark" :content="item.location" placement="bottom">
                        <p class="local" v-if="item.location">{{ $t('positionB') }}: {{ item.location }}</p>
                      </el-tooltip>
                    </h5>
                  </div>
                  <!-- 轨迹 -->
                  <div
                    class="tags-list gps-item"
                    :class="isDefaultTheme ? '' : 'gps-dark'"
                    v-if="item.mediaType === 3"
                    @click="playTrackItem(item)"
                  >
                    <el-checkbox
                      :label="item"
                      class="check-item"
                      v-if="showType"
                      @click.stop.native="() => {}"
                    ></el-checkbox>
                    <div class="cate-type" v-if="item.fullTypeAttributeName">
                      <img src="@/icon/cate.png" class="cate" title="切换类别" />
                      <span v-if="item.mediaTypeName"> {{ item.mediaTypeName }}</span>
                    </div>
                    <div class="vedio-time">
                        <div class="local" :class="item.location ? '' : 'local-height'">
                          {{ item.userName }} | {{ item.logTimestamp }}
                        </div>
                      <el-tooltip effect="dark" :content="item.location" placement="bottom">
                        <div class="local" v-if="item.location">{{ $t('positionB') }}: {{ item.location }}</div>
                      </el-tooltip>
                      
                    </div>
                  </div>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <Categorys v-if="showType" ref="categorys" @handletypeNode="handleNode" @handleCate="handleCate"></Categorys>
        </div>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="formInline.pageNum"
          :page-sizes="[15, 20, 50, 100]"
          :page-size="formInline.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
  </transition>
</template>
<script>
// 依赖组件
import HistoryVideo from '@/components/new-historyVideo/Index.vue'
import OneHistoryVideo from '@/components/HistoryVideo.vue'
import DataType from '@/views/new-dataMange/DataType.vue'
import Categorys from '@/views/new-dataMange/Categorys.vue'
import { getOus } from '@/api/UserList'
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import { downloadZip } from '@/util/file'
import { batchDownloadMedias } from '@/api/log/mediaTag'

import { dataPage, dataUpdate, unionFindByGroup } from '@/api/data-mange'
import { mapGetters } from 'vuex'
import { attributeTree } from '@/api/new-device/categoryAttribut'

export default {
  components: {
    DataType,
    HistoryVideo,
    Categorys,
    VueDraggableResizable,
    OneHistoryVideo,
  },
  data() {
    return {
      // 查询表单
      formInline: {
        attributeId: '', // 类别归属id
        mediaType: '', // 文件类型
        logTimestampEnd: '',
        logTimestampBegin: '',
        userName: '',
        pageNum: 1,
        pageSize: 15,
        sort: 'desc',
        collation: 'log_timestamp',
      },
      ouName: '',
      totalData: 0,
      defaultProps: {
        label: 'name',
        children: 'children',
      },
      radio1: '',
      // 查询机构树数据
      ouList: [],
      positionTypes: [
        {
          value: 3,
          label: this.$t('trajectory'),
        },
        {
          value: 2,
          label: this.$t('pictureS'),
        },
        {
          value: 1,
          label: this.$t('videoS'),
        },
      ],
      checkboxGroup1: [],
      coverSrc: require('@/icon/monitor/coverPlaceDark.png'),
      coverSrcDefault: require('@/icon/monitor/coverPlaceLight.png'),
      mediaList: [],
      // 显示分类选择框
      showType: false,
      classifyTxt: this.$t('fileClassification'),
      currentItem: {},
      // 选择的分类
      selectType: {},
      // 播放器开关
      videoShow: false,
      playVideoData: [],
      videoIndex: null,
      historyData: {},
      width: 780,
      height: 560,
      x: 0,
      y: 0,
      // 允许拖拽
      allowDrag: true,
      dataUserId: '',
      // 视频播放视频id
      firstId: '',
      // 类型查询
      searchType: 'type',
      userList: [],
      allTxt: this.$t('selectAll'),
      checkAll: false,
      isIndeterminate: true,
      allChecked: [],
      sortRadio: 'log_timestamp',
      downloadLoading: false,
      radioData: [
        {
          label: 'log_timestamp',
          name: this.$t('time'),
        },
        {
          label: 'user_name',
          name: this.$t('userNameH'),
        },
        {
          label: 'media_type',
          name: this.$t('fileType'),
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['isDefaultTheme']),
  },
  mounted() {
    if (this.$route.query && this.$route.query.id) {
      this.formInline.userId = this.$route.query.id
      this.formInline.userName = this.$route.query.name
      this.dataUserId = this.$route.query.id
    }
    this.getOusTree()
    this.getAttributeTree()
    this.getdatePage()
  },
  methods: {
    getAllow(type,w,h,x,y) {
      this.allowDrag = type
      this.width = w ? w : this.width
      this.height = h ? h : this.height 
      this.x = x+'' ? x : this.x
      this.y = y+'' ? y: this.y
    },
    // 获取类别归属树
    getAttributeTree() {
      let param = {
        isContainMediaType: 0,
        isReject: 1, // 1:不包含 0:包含
      }
      attributeTree(param).then(res => {
        if (res.state === 0) {
          this.userList = res.value
        }
      })
    },
    handleDownload() {
      if (this.checkboxGroup1 && this.checkboxGroup1.length === 0) {
        this.$message({
          message: this.$t('selectFileDownload'),
          type: 'warning',
        })
        return
      }
      console.log(this.checkboxGroup1, '下载')
      if (
        (this.checkboxGroup1 && this.checkboxGroup1.length === 1 && !this.checkboxGroup1[0].uploadFlag) ||
        this.checkboxGroup1[0].status === 1
      ) {
        this.$message({
          message: this.$t('iploadFileDoesnoSupport'),
          type: 'warning',
        })
        return
      }
      this.allChecked = []
      let hasTrack = []
      this.checkboxGroup1.map((item, index) => {
        hasTrack.push(item.mediaType)
        if (item.mediaType !== 3 && item.uploadFlag && item.status !== 1) {
          this.allChecked.push({
            userId: item.userId,
            logTimestamp: item.logTimestamp,
            type: item.mediaType,
            groupActual: item.group ? item.group : '',
          })
        }
      })
      if (this.allChecked.length > 50) {
        this.$message({
          message: this.$t('upTo50Files'),
          type: 'warning',
        })
        return
      }
      if (hasTrack.includes(3)) {
        this.$message({
          message: this.$t('trackFileDoesnoSupport'),
          type: 'warning',
        })
      }
      if (this.allChecked.length > 0) {
        this.batchDownlown()
      } else {
        this.checkboxGroup1 = []
        this.allChecked = []
      }
    },
    // 批量下载
    batchDownlown() {
      this.downloadLoading = true
      batchDownloadMedias(this.allChecked).then(res => {
        if (res['type'] !== 'text/xml') {
          this.$message({
            message: this.$t('downloadFile'),
            type: 'warning',
          })
          this.downloadLoading = false
          return
        } else {
          downloadZip(res, this.$t('batchDownload'))
          this.$message({
            message: this.$t('downloadingFile'),
            type: 'success',
            duration: 3000,
          })
          this.downloadLoading = false
        }

        this.checkboxGroup1 = []
        this.allChecked = []
      })
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    // 清除用户名置空参数
    handleClear(val) {
      if (!val) {
        this.formInline.userName = ''
        this.formInline.userId = ''
        this.dataUserId = ''
        this.$router.replace({ path: '/newIndex/mediaData', query: {} })
      }
    },
    onResize: function(x, y, width, height) {
      this.x = x
      this.y = y
      this.width = width
      this.height = height
    },
    onDrag: function(x, y) {
      this.x = x
      this.y = y
    },
    // 点击左侧树
    handleItem(data, type, value) {
      this.searchType = type
      this.formInline.pageNum = 1
      if (value) {
        this.userList = value
      }
      if (!data) {
        this.formInline.attributeId = ''
        this.formInline.mediaTypeId = ''
        this.formInline.userId = ''
        this.formInline.ouId = ''
        this.ouName = ''
        this.getdatePage()
        return
      }
      if (type === 'type') {
        // 类型查询
        this.formInline.userId = ''
        if (data.type === 1) {
          // type === 1 归属id查询
          this.formInline.attributeId = data.id
          this.formInline.mediaTypeId = ''
        } else {
          // 0： 类别名称查询
          this.formInline.attributeId = ''
          this.formInline.mediaTypeId = data.mediaTypeId
        }
      } else {
        // 用户查询
        this.formInline.userId = data.userId
      }
      this.currentItem = data
      this.getdatePage()
    },
    // 查询媒体文件
    getdatePage() {
      this.allTxt = this.$t('selectAll')
      dataPage(this.formInline).then(res => {
        if (res.state === 0) {
          this.mediaList = res.value.list
          this.totalData = res.value.total
        }
      })
    },
    handleSizeChange(val) {
      this.formInline.pageSize = val
      this.getdatePage()
    },
    handleCurrentChange(val) {
      this.formInline.pageNum = val
      this.getdatePage()
    },
    // 获取组织机构
    getOusTree() {
      getOus().then(res => {
        if (res.state === 0) {
          this.ouList = res.value
        }
      })
    },
    // 选中过滤条件机构，过滤用户
    selectParamOu(data) {
      if (data.mediaTypeId) {
        this.formInline.mediaTypeId = data.mediaTypeId
        this.formInline.ouId = ''
      } else {
        this.formInline.mediaTypeId = ''
        this.formInline.ouId = data.id
      }
      this.ouName = data.name

      this.$refs.paramOuSelect.blur()
    },
    // 清空过滤条件机构
    clearParamOuTree() {
      this.ouName = ''
      this.formInline.ouId = ''
      this.formInline.mediaTypeId = ''
    },
    // 全选当前页
    allSelect() {
      this.allTxt = this.allTxt === this.$t('selectAll') ? this.$t('deselectDll') : this.$t('selectAll')
      if (this.allTxt === this.$t('deselectDll')) {
        this.checkboxGroup1 = this.mediaList
        this.checkAll = true
        this.isIndeterminate = false
      } else {
        this.checkboxGroup1 = []
        this.isIndeterminate = true
      }
    },
    handleCate(type) {
      if (type === 'save') {
        this.classify()
      } else if (type === 'back') {
        this.backSify()
      }
    },
    // 点击归类
    classify() {
      if (!this.showType) {
        this.showType = true
      } else {
        if (this.checkboxGroup1 && this.checkboxGroup1.length === 0) {
          this.$message({
            message: this.$t('selectFilesCategorize'),
            type: 'warning',
          })
          return
        } else if (!this.selectType.mediaTypeId || this.selectType.mediaTypeId === '') {
          this.$message({
            message: '请选择类别',
            type: 'warning',
          })
          return
        }
        this.checkboxGroup1.map(item => {
          item.mediaTypeId = this.selectType.mediaTypeId
          item.mediaTypeName = this.selectType.name
        })

        setTimeout(() => {
          this.subMediasType()
        }, 200)
      }
    },
    // 选择类别名称后
    handleNode(data) {
      this.selectType = data
    },
    // 文件批量归类
    subMediasType() {
      dataUpdate(this.checkboxGroup1).then(res => {
        if (res.state === 0) {
          this.checkboxGroup1 = []
          this.selectType = {}
          this.$refs.categorys.handleClear()
          this.getdatePage()
          this.$message({
            message: this.$t('categorizedSuccess'),
            type: 'success',
          })
        }
      })
    },
    // 取消归类
    backSify() {
      this.showType = false
      this.checkboxGroup1 = []
      this.selectType = {}
      this.allTxt = this.$t('selectAll')
      this.classifyTxt = this.$t('fileClassification')
    },
    // 点击查询
    getList() {
      this.formInline.pageNum = 1
      this.getdatePage()
    },
    handlecoll(el, data) {
      // 点击会执行两次
      if (el.target.tagName === 'INPUT') return
      if (data === this.formInline.collation) {
        // 点击同一个字段=》进行正序倒叙
        if (this.formInline.sort === 'asc') {
          this.formInline.sort = 'desc'
        } else {
          this.formInline.sort = 'asc'
          this.formInline.collation = data
        }
      } else if (data !== this.formInline.collation) {
        this.formInline.collation = data
        this.formInline.sort = 'desc'
      }
      this.getdatePage()
    },
    // 播放视频
    playMedia(item) {
      console.log(item, '播放视频')
      this.playVideoData = []
      this.firstId = item.id
      if (item.group) {
        // 根据视频组id请求视频
        let param = {
          group: item.group,
        }
        unionFindByGroup(param).then(res => {
          if (res.state === 0) {
            this.playVideoData = [res.value]
            this.videoIndex = 0
            this.historyData = res.value
            this.videoShow = true
          }
        })
      } else if (item.mediaUrl) {
        // 无法请求视频组，单个视频播放
        this.playVideoData = [item]
        this.videoIndex = 0
        this.historyData = item
        this.videoShow = true
      } else {
        this.$message({
          message: this.$t('videoCannotPlayed'),
          type: 'warning',
        })
        return
      }
    },
    cancleVideoShow() {
      this.videoShow = false
      this.firstId = ''
      this.allowDrag = true
      this.width = 780
      this.height = 560
      this.x = 0
      this.y = 0
    },
    searchList() {},
    // 播放轨迹
    playTrackItem(item) {
      let data = []
      let index = 0
      data.push(item)
      this.$store.commit('updatePlayTrail', true)
      this.$store.commit('updateTrailData', data)
      this.$store.commit('updateTrailIndex', index)
      this.$emit('update:currentItem', data[index])
    },
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
@import '~@/style/common.styl'
@import '~@/style/mixin.styl'
.common-blue-contain
  >>>.el-radio-button__orig-radio:checked+.el-radio-button__inner
    background: #D3EEFF;
    color: #0E65DD;
    box-shadow none
    border-color: #D3EEFF;
  >>>.el-radio-button--small .el-radio-button__inner
    color #222
    font-size 14px
    font-weight 400
  .common-main
    position: absolute
    top: 40px
    left: 16%
    height: 96%;
    width: 83%
    .datetime
      margin-right 5px!important
    .serach
      margin-top: 10px!important
    .cate-content
      height: 81.8%;
      width: 100%
      display: flex
    .content
      width: 100%
      border: 1px solid var(--new-input-focus-border);
      height: 100%;
      position: relative
      .content-select
        display flex
        align-items center
        margin 0 20px
        border-bottom 1px solid #DCDFE6
        position: relative
      .sieve-series
        display: flex
        position: absolute
        right: 0
        bottom: 0
        >>>.el-radio-button--small .el-radio-button__inner
          padding 8px!important
        .icon-right
          display: inline-block
          width 8px
          height 9px
        .icon-download
          bg-image('~@/icon/new-common/arrow_ backlow1.png')
        .icon-downLight
          bg-image('~@/icon/new-common/arrow_low.png')
        .icon-uploadLight
          bg-image('~@/icon/new-common/arrow_up.png')

      .exVideo
        background #fff
        position fixed
        border: 1px solid rgba(0, 222, 255, 0.5);
        z-index: 999
        #amplifyVideo
          pointer-events: auto
          background #fff
          position fixed
          left: 30%
          top: 20%
          width 560px
          border: 1px solid rgba(0, 222, 255, 0.5)
          z-index: 9999
        .exVideoTitle
          color #0E65DD
          display flex
          justify-content: space-between;
          align-items: center;
          background url('~@/icon/newBg/img_head1.png') no-repeat
          background-size 100% 39px
          padding-left 46px
          line-height 39px
          span
            font-size: 18px;
            font-weight: bold;
          .sys-close-btn
            margin-right 5px
      .groups
        width: calc(100% - 18px)
        height: 100%
        overflow: auto
        padding-right 18px
        scrollbar-gutter: table
        &::-webkit-scrollbar
          width 6px
          height 6px
          background-color #fff
        &::-webkit-scrollbar-thumb
          width 6px
          background-color #ddd
      .medias
        overflow: hidden;
        width: 100%;
        height: calc(100% - 40px);/*no*/

        .media-item
          float: left
          width: 18.7%
          height: 185px
          margin-left 19px
          margin-top 15px
          box-sizing: border-box

          .tags-list
            position relative
            border: 1px solid #00A0E9;
            border-radius: 6px;
            height: 100%
            box-sizing: border-box
            .box
              width 100%
              height 100%
            .delete
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              .upper
                width 40px
                height 40px
              .upper-text
                font-size 14px
                font-weight 400
                color #4ABE7B
            .uper-delete
              .upper-text
                color #B41616
            .check-item
              position: absolute;
              top: 1px;
              left: 1px;
              >>>.el-checkbox__label
                display: none
            .cate-type
              position: absolute;
              top: 1px;
              right: 1px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              font-size: 14px;
              color: #54e9ff;
              padding 0 10px
              background-color: rgba(0, 0, 0, 0.5);
              border-radius: 0 4px 0 6px;
              z-index: 1;
              .cate
                margin-right: 5px
            .play-icon
              position: absolute;
              top: 50%;
              left: 50%;
              width: 41px;
              height: 41px;
              transform: translate(-50%, -50%);
            .vedio-time
              position: absolute;
              bottom: 1px;
              left: 0px;
              width: calc(100% - 10px);
              height: 48px;
              line-height: 24px;
              padding-left: 10px;
              font-size: 13px;
              background-color: rgba(0, 0, 0, 0.5);
              color: #fff
              border-radius: 0 0 5px 5px;
              .local
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              .local-height
                line-height 48px
            .pic
              width: 100%;
              height: 100%;
              cursor: pointer
              border-radius: 6px;
          &:nth-child(1)
            margin-top 5px
          &:nth-child(2)
            margin-top 5px
          &:nth-child(3)
            margin-top 5px
          &:nth-child(4)
            margin-top 5px
          &:nth-child(5)
            margin-top 5px
          .gps-item
            bg-image('~@/icon/trace-lign.png')
            .centr-icon
              width: 60px;
              height: 60px;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              background: #0e65dd
              border-radius: 6px
              cursor: pointer
          .gps-dark
            bg-image('~@/icon/trace-night.png')
        .type-item
          width: 18.4%
>>> .el-tree-node__content
  font-weight: 400
  color: var(--new-el-select-dropdown-item)
.el-button--primary.is-plain
  color #409EFF
  background: #ecf5ff;
  border-color: #b3d8ff;
.theme-dark
  .el-button--primary.is-plain
    color #002A96
    background: #00DEFF;
    border-color: #00DEFF;
  .common-blue-contain
    >>>.el-radio-button__orig-radio:checked+.el-radio-button__inner
      background: #295AFF
      color: #00DEFF
      border-color: #295AFF
    >>>.el-radio-button--small .el-radio-button__inner
      color #fff
      background: none
      border 1px solid #295AFF
    .common-main
      .content
        border 1px solid rgba(5, 126, 250, 0.3)
        .groups
          &::-webkit-scrollbar
            background-color rgba(0, 42, 150, 0.5)
          &::-webkit-scrollbar-thumb
            background-color #2A5CBA
        .content-select
          border-bottom 1px solid rgba(5, 126, 250, 0.3)
        .sieve-series
          .icon-download
            bg-image('~@/icon/new-common/arrow1-lowWihte.png')
          .icon-downLight
            bg-image('~@/icon/new-common/arrow-lowdark.png')
          .icon-uploadLight
            bg-image('~@/icon/new-common/arrow-upNow.png')
        .exVideo
          #amplifyVideo
            background #041d5d
          .exVideoTitle
            color #00E4FF
            background url('~@/icon/newBg/img_head1-m.png') no-repeat
</style>
